import { useTranslation } from "react-i18next";

export interface LogoPlaceholderProps {
  /** Extra class controlling size/shape for the host slot. */
  className?: string;
  /** Border + text color; defaults to `currentColor` so it inherits the theme slot. */
  color?: string;
}

/**
 * Gallery-only stand-in for a partner logo that production resolves from
 * configuration (`session.data.partner.logoUrl`). The screenbook has no real
 * partner, so instead of rendering an unrelated image we draw a dashed box
 * with a "Logo" label to make the reserved space visible.
 *
 * Brand/asset marks (Visa, Mastercard, stores, ...) are real and must NOT use
 * this component.
 */
export const LogoPlaceholder = ({ className, color }: LogoPlaceholderProps) => {
  const { t } = useTranslation();

  return (
    <span
      className={`logo-placeholder${className ? ` ${className}` : ""}`}
      aria-hidden="true"
      style={color ? { borderColor: color, color } : undefined}
    >
      {t("common.logoPlaceholder")}
    </span>
  );
};
